import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InsertCommentIcon from '@material-ui/icons/InsertComment';

import useStyles from './assetStyle';
import ItecDialog from '../../../modules/checkListGenerator/itechChecklist/itechAddRelevancePopUp';

export default function ItechAccordinDet5() {
    const classes = useStyles();
    const [itecOpen, setItecOpen] = React.useState(false);

    const [open, setOpen] = React.useState(false);
    const [country, setCountry] = React.useState('Enter Country');

    const handleChange = (event) => {
        setCountry(event.target.value);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };
    const handleRelevence = () => {
        //console.log('handleRele++++');
        setItecOpen(true);
    };
    const handleItecClose = () => {
        setItecOpen(false);
    };

    const [formValues, setFormValues] = React.useState({
        country: 'Enter Country Name',
        trustName: 'Enter Name',
        trustAddress: 'Enter Address',
        trusteeName: 'Enter Name',
        trusteeAddress: 'Enter Address',
        settlorName: 'Enter Name',
        settlorAddress: 'Enter Address',
        benfName: 'Enter Name',
        benfAddress: 'Enter Address',
    });

    return (
        <>
            <Grid container spacing={2} className="main-container">
                <Grid item xs={10} sm={6} className={classes.marginBtm}>
                    <FormControl fullWidth>
                        <InputLabel className={classes.inLabel} htmlFor="country-name">
                            Country Name
                        </InputLabel>
                        <Select
                            disabled
                            id="country-name"
                            className={classes.bottomLine}
                            value={country}
                            open={open}
                            onClose={handleClose}
                            onOpen={handleOpen}
                            onChange={handleChange}
                            IconComponent={() => <FontAwesomeIcon icon={faAngleDown} />}
                        >
                            <MenuItem value="Enter Country">Enter Country</MenuItem>
                            <MenuItem value="India">India</MenuItem>
                            <MenuItem value="Nepal">Nepal</MenuItem>
                            <MenuItem value="Sri Lanka">Sri Lanka</MenuItem>
                        </Select>
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={10} sm={6} className={classes.marginBtm}>
                    <FormControl fullWidth>
                        <InputLabel className={classes.inLabel} htmlFor="trust-name">
                            Name of the trust
                        </InputLabel>
                        <Input disabled className={classes.bottomLine} id="trust-name" value={formValues.trustName} />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={10} sm={6} className={classes.marginBtm}>
                    <FormControl fullWidth>
                        <InputLabel className={classes.inLabel} htmlFor="trust-address">
                            Address of the trust
                        </InputLabel>
                        <Input disabled className={classes.bottomLine} id="trust-address" value={formValues.trustAddress} />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={10} sm={6} className={classes.marginBtm}>
                    <FormControl fullWidth>
                        <InputLabel className={classes.inLabel} htmlFor="trustee-name">
                            Name of the other trustees
                        </InputLabel>
                        <Input disabled className={classes.bottomLine} id="trustee-name" value={formValues.trusteeName} />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={10} sm={6} className={classes.marginBtm}>
                    <FormControl fullWidth>
                        <InputLabel className={classes.inLabel} htmlFor="trustee-address">
                            Address of other trustees
                        </InputLabel>
                        <Input disabled className={classes.bottomLine} id="trustee-address" value={formValues.trusteeAddress} />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={10} sm={6} className={classes.marginBtm}>
                    <FormControl fullWidth>
                        <InputLabel className={classes.inLabel} htmlFor="settlor-name">
                            Name of settlor
                        </InputLabel>
                        <Input disabled className={classes.bottomLine} id="settlor-name" value={formValues.settlorName} />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={10} sm={6} className={classes.marginBtm}>
                    <FormControl fullWidth>
                        <InputLabel className={classes.inLabel} htmlFor="settlor-address">
                            Address of settlor
                        </InputLabel>
                        <Input disabled className={classes.bottomLine} id="settlor-address" value={formValues.settlorAddress} />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={10} sm={6} className={classes.marginBtm}>
                    <FormControl fullWidth>
                        <InputLabel className={classes.inLabel} htmlFor="benf-name">
                            Name of beneficiaries
                        </InputLabel>
                        <Input disabled className={classes.bottomLine} id="benf-name" value={formValues.benfName} />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                <Grid item xs={10} sm={6} className={classes.marginBtm}>
                    <FormControl fullWidth>
                        <InputLabel className={classes.inLabel} htmlFor="benf-address">
                            Address of beneficiaries
                        </InputLabel>
                        <Input disabled className={classes.bottomLine} id="benf-address" value={formValues.benfAddress} />
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            className={classes.button}
                            startIcon={<InsertCommentIcon />}
                            onClick={handleRelevence}
                        >
                            Add Relevance
                        </Button>
                    </FormControl>
                </Grid>
                {/* <Grid item xs={12} sm={12} className={classes.marginBtm}>
                <Button variant="outlined" color="primary" className="txt-capitalize">
                    Add More
                </Button>
            </Grid> */}
            </Grid>
            {itecOpen && <ItecDialog itecOpen={itecOpen} handleItecClose={handleItecClose} />}
        </>
    );
}
